import { NodeViewProps } from '@tiptap/react'

import { IconButton } from '@tribeplatform/react-ui-kit/Button'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'

import { EventNodeComponent } from '../../../Event/EventNodeComponent.js'
import { Container } from '../Container.js'

export const EventNodeContent = (props: NodeViewProps) => {
  const { node, deleteNode } = props
  const { id } = node.attrs

  return (
    <Container {...props}>
      <EventNodeComponent id={id} interactive={false} />
      <IconButton
        as="div"
        icon={<SvgIcon name="close" />}
        variant="secondary"
        size="sm"
        className="!absolute top-0 end-0 m-1 z-10 cursor-pointer"
        onClick={deleteNode}
      />
    </Container>
  )
}
